import { useCallback } from "react";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";
import AmountEditor from "../../../components/AmountEditor/AmountEditor";
import { calcNewAmountOnIncrement } from "./paymentUtils";

function AmountField (props) {
    const {
        className,
        currencyNotionalAmount,
        currencyNotionalParams,
        description,
        editCurrencyNotional,
        error,
        handleCurrencyNotionalAmountChange,
        handleUsdAmountChange,
        setEditCurrencyNotionalAmount,
        usdAmount,
    } = props;
    const {getLangPath} = useLangContext();

    const handleUsdAmountChangeEvent = useCallback((e) => {
        handleUsdAmountChange(e.currentTarget.innerText.replaceAll(',', '.'));
    }, [handleUsdAmountChange]);

    const handleCurrencyNotionalAmountChangeEvent = useCallback((e) => {
        handleCurrencyNotionalAmountChange(e.currentTarget.innerText.replaceAll(',', '.'));
    }, [handleCurrencyNotionalAmountChange]);

    const handleSwitchAmount = useCallback(() => {
        setEditCurrencyNotionalAmount(editCurrencyNotional => !editCurrencyNotional);
    }, [setEditCurrencyNotionalAmount]);

    const handleButtonClick = useCallback((e) => {
        const value = e.currentTarget.dataset.value;
        const currentAmount = editCurrencyNotional ? currencyNotionalAmount : usdAmount;
        const newAmount = calcNewAmountOnIncrement(currentAmount, value === 'plus');
        if (editCurrencyNotional) {
            handleCurrencyNotionalAmountChange(newAmount);
        } else {
            handleUsdAmountChange(newAmount);
        }
    }, [usdAmount, currencyNotionalAmount, editCurrencyNotional, handleUsdAmountChange, handleCurrencyNotionalAmountChange]);

    return <div className={className}>
        <AmountEditor
            description={description}
            editMainAmount={!editCurrencyNotional}
            error={!!error && getLangPath(error)}
            label={getLangPath('deposit.amount')}
            mainAmountChangeHandler={handleUsdAmountChangeEvent}
            mainAmountLabel={`$${usdAmount}`}
            mainAmountPrefix={'$'}
            mainAmountValue={usdAmount}
            onButtonClick={handleButtonClick}
            secondaryAmountChangeHandler={handleCurrencyNotionalAmountChangeEvent}
            secondaryAmountLabel={currencyNotionalParams ? `${currencyNotionalParams.unit}${currencyNotionalAmount}` : undefined}
            secondaryAmountPrefix={currencyNotionalParams?.unit}
            secondaryAmountValue={currencyNotionalAmount}
            switchAmountHandler={currencyNotionalParams ? handleSwitchAmount : undefined}
        />
    </div>
}

export default AmountField;
